import React from 'react'
import PropTypes from 'prop-types'
import Download from 'material-ui/svg-icons/action/get-app'
import RaisedButton from 'material-ui/RaisedButton'
import css from './styles.css'

const downloadIcon = <Download />

const DownloadButton = ({
  disabled,
  downloading,
  handleDownload,
}) => (
  <div className={css.downloadContainer}>
    <RaisedButton
      disabled={disabled}
      onClick={handleDownload}
      label={downloading ? 'Downloading' : 'Download'}
      icon={downloadIcon}
    />
  </div>
)

DownloadButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  downloading: PropTypes.bool.isRequired,
  handleDownload: PropTypes.func.isRequired,
}

export default DownloadButton



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/DownloadButton.js